function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   cursor: pointer;\n   background-color: transparent;\n   border: none;\n   padding: 0 1.5rem;\n   border-right: 1px solid #003c69;\n   margin-right: -2rem;\n   outline: none;\n\n   & > span,\n   & > span::after,\n   & > span::before {\n      position: relative;\n      display: block;\n      background-color: ", ";\n      width: 1.5rem;\n      height: 2px;\n      transition: transform 0.5s ease, background 0.5s ease;\n   }\n\n   & > span::after,\n   & > span::before {\n      content: '';\n      position: absolute;\n   }\n\n   & > span::before {\n      bottom: -7px;\n   }\n\n   & > span::after {\n      top: -7px;\n   }\n\n   :hover,\n   :focus {\n      outline: none;\n\n      & > span,\n      & > span::after,\n      & > span::before {\n         background-color: ", ";\n      }\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import React, { useContext } from 'react';
import { SiteHeaderContext } from './SiteHeaderContext';
import { ScreenReaderOnly } from '../../a11y/ScreenReaderOnly';
var StyledHamburgerButton = styled.button(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.brandColors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.semanticColors.secondary;
});

var TopNavHamburgerButton = function TopNavHamburgerButton() {
  var _useContext = useContext(SiteHeaderContext),
      mobileMenuOpen = _useContext.mobileMenuOpen,
      setMobileMenuOpen = _useContext.setMobileMenuOpen;

  return /*#__PURE__*/React.createElement(StyledHamburgerButton, {
    "data-rcl-hamburger-button": true,
    onClick: function onClick() {
      return setMobileMenuOpen(!mobileMenuOpen);
    }
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "".concat(mobileMenuOpen ? 'Close' : 'Open', " Navigation Menu"))));
};

export { TopNavHamburgerButton };